<template lang="pug">
  .ruler
    button.ruler__button(:class="{ 'ruler__button--selected': selected.value === cover.value }" @click.prevent="handlerSelectedValueCover" v-for="(cover, index) in currentCoverageValues" :key="index") {{ cover.value }}
</template>

<script>
export default {
  name: 'RulerCovidCover',
  props: {
    selected: Boolean,
    currentCoverageValues: Array,
    handlerSelectedValueCover: Function
  }
}
</script>

<style lang="scss">
@import "~@/style/ui/variables";

.ruler {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__button {
    width: 100%;
    max-width: 246px;
    height: 68px;
    background-color: #fff;
    border: 1px solid #bdc2c6;
    border-radius: 8px;
    font-size: 24px;
    font-weight: bold;
    color: #444;
    font-family: $oscine-font-family;
    line-height: 1;
    cursor: pointer;

    &--selected {
      background-color: rgba(135, 90, 255, 0.1);
      border-width: 2px;
      border-color: #6320e9;
    }
  }
}
</style>
